import React, { useMemo, useState } from 'react';

import { buildContext } from '@tectonics/utils/context';

export type FormStatus = 'initial' | 'sending' | 'sent';

type FormStatusContextType = [FormStatus, (status: FormStatus) => void];

const formStatusContext = buildContext<FormStatusContextType>('FormStatusContext');

export const FormStatusContext = formStatusContext.Context;
export const useFormStatusContext = formStatusContext.useContext;

interface FormStatusContextProviderProps {
  readonly children: React.ReactNode;
}

export function FormStatusContextProvider({
  children,
}: FormStatusContextProviderProps): React.ReactNode {
  const [formStatus, setFormStatus] = useState<FormStatus>('initial');

  const providedFormStatusContext = useMemo<FormStatusContextType>(
    () => [formStatus, setFormStatus],
    [formStatus, setFormStatus],
  );

  return (
    <FormStatusContext.Provider value={providedFormStatusContext}>
      {children}
    </FormStatusContext.Provider>
  );
}

export function useFormHasBeenSent(): boolean {
  const [formStatus] = useFormStatusContext();
  return formStatus === 'sent';
}
